<div class="page-container">
  <div class="header-section">
    <div class="title-block">
      <h1>Menu Management</h1>
      <div class="subtitle">Set which menus are visible for each role.</div>
    </div>

    <div class="header-actions">
      <button class="btn-secondary" type="button" (click)="selectAll()" [disabled]="!selectedRole || saving">
        <span class="material-icons">select_all</span>
        Select all
      </button>
      <button class="btn-secondary" type="button" (click)="clearAll()" [disabled]="!selectedRole || saving">
        <span class="material-icons">clear_all</span>
        Clear
      </button>
      <button class="btn-primary" type="button" (click)="save()" [disabled]="!selectedRole || saving">
        <span class="material-icons">save</span>
        Save
      </button>
    </div>
  </div>

  <div class="filter-section">
    <div class="role-select-row">
      <label class="form-label">Role</label>
      <p-select [filter]="true" [options]="roles" optionLabel="roleName" [(ngModel)]="selectedRole"
        (ngModelChange)="onRoleChange($event)" placeholder="Select role">
      </p-select>
      <span class="result-count" *ngIf="selectedRole">{{ selectedMenuKeys.size }} menus selected</span>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
    <p>Loading menu setup...</p>
  </div>

  <app-empty-state *ngIf="!loading && roles.length === 0" icon="admin_panel_settings" headline="No roles found"
    subline="Create roles before assigning menus.">
  </app-empty-state>

  <div class="menu-setup-grid" *ngIf="!loading && selectedRole">
    <section class="menu-setup-card" *ngIf="topLevelMenus.length > 0">
      <div class="menu-setup-card__header">
        <span class="material-icons">apps</span>
        Main Menus
      </div>

      <label class="menu-option" *ngFor="let menu of topLevelMenus; trackBy: trackByMenuKey">
        <input type="checkbox" [checked]="isSelected(menu.key)" (change)="toggleMenu(menu.key, $any($event.target).checked)" />
        <span class="material-icons">{{ menu.icon }}</span>
        <span>{{ menu.label }}</span>
      </label>
    </section>

    <section class="menu-setup-card" *ngFor="let group of groupedMenus; trackBy: trackByGroupKey">
      <div class="menu-setup-card__header">
        <span class="material-icons">{{ group.icon }}</span>
        {{ group.label }}
      </div>

      <label class="menu-option" *ngFor="let menu of group.items; trackBy: trackByMenuKey">
        <input type="checkbox" [checked]="isSelected(menu.key)" (change)="toggleMenu(menu.key, $any($event.target).checked)" />
        <span class="material-icons">{{ menu.icon }}</span>
        <span>{{ menu.label }}</span>
      </label>
    </section>
  </div>
</div>
